import axios from 'axios';

import { getAccessToken } from './axios'; // Import the token getter

const uploadAxiosInstance = axios.create({
	// Set timeout to 2 hours for large uploads
	timeout: 120 * 60 * 1000,
	// Set maximum content length to 512MB
	maxContentLength: 512 * 1024 * 1024,
	maxBodyLength: 512 * 1024 * 1024,
	headers: {
		'Content-Type': 'multipart/form-data',
	},
});

uploadAxiosInstance.defaults.baseURL =
	import.meta.env.VITE_WEBCAU_MODE === 'dev'
		? import.meta.env.VITE_NGINX_URL_DEV
		: import.meta.env.VITE_NGINX_URL_PROD;

uploadAxiosInstance.interceptors.request.use(
	(config) => {
		const token = getAccessToken(); // Use the getter
		if (token) {
			config.headers.Authorization = `Bearer ${token}`;
		}
		return config;
	},
	(error) => Promise.reject(error)
);

export { uploadAxiosInstance };
